import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import { SecureApi } from '../../../core/secure.api';

@Injectable()
export class MePasswordResetService {
    constructor(
        public http: HttpClient, 
        @Inject('baseUrl') public baseUrl: string
    ) {

    }

    changePassword(token: string, password: string, passwordConfirmation: string) {
        const url = this.baseUrl + 'oauth/password/change';

        let httpParams = new HttpParams()
                                .append('token', token)
                                .append('password', password)
                                .append('is_b2c', true)
                                .append('password_confirmation', passwordConfirmation);

        const body = httpParams.toString();

        const headerOptions = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };

        const httpOptions = {
            headers: new HttpHeaders(headerOptions)
        };

        return this.http.post(url, body, httpOptions);
    }
}
